export enum IntegrationTypeEnum {
	Provided = 1,
	Consumed = 2,
}
